import { FC } from 'react';

import './OpenAIBranding.scss';

export const PoweredByOpenAI: FC = () => {
    return <span className="powered-by">Powered by OpenAI</span>;
};
